const numericAmount = values => {
  for (const value of values) {
    if (value != null && String(value).trim() !== '' && Number.isFinite(Number(value))) {
      return Math.abs(Number(value))
    }
  }
  return 0
}

export const getBankAssignedAmount = (item, linkage, document, selected = false) => {
  const bankId = item?.idPrincipal ?? item?.id
  const linked = (Array.isArray(linkage) ? linkage : []).find(row =>
    bankId != null && String(row?.idPrincipal ?? row?.id) === String(bankId)
  )
  const documentId = document?.idPrincipal ?? document?.id
  const reverseLinked = (Array.isArray(item?.linkage) ? item.linkage : []).find(row =>
    documentId != null && String(row?.idPrincipal ?? row?.id) === String(documentId)
  )
  const applied = linked?.monto ?? linked?.montoRelacionado ??
    reverseLinked?.monto ?? reverseLinked?.montoRelacionado
  if (applied != null) return numericAmount([applied])
  return selected ? getVinculacionAppliedAmount(item) : null
}

export const getVinculacionBankAmount = (item, linked) => numericAmount([
  linked?.montoTotal, item?.montoTotal, item?.montoCargo || item?.montoAbono,
  item?.haber || item?.debe, item?.amount
])

export const getVinculacionAvailableAmount = item => numericAmount([
  item?.auxiliar, item?.deuda?.auxiliar, item?.montoTotal,
  item?.montoCargo || item?.montoAbono, item?.haber || item?.debe, item?.amount, item?.monto
])

export const getVinculacionAppliedAmount = (item, linked) => {
  if (item?.customRow === true) return numericAmount([item.montoEditable, item.monto])
  return numericAmount([
    linked?.monto, linked?.montoRelacionado, item?.monto, item?.montoRelacionado,
    item?.montoEditable, item?.montoCargo || item?.montoAbono,
    item?.haber || item?.debe, item?.montoTotal, item?.amount
  ])
}

export const getVinculacionPendingAmount = (auxiliary, total, linkedApplied, selectedApplied) => {
  const hasAuxiliary = auxiliary != null && String(auxiliary).trim() !== '' && Number.isFinite(Number(auxiliary))
  return hasAuxiliary
    ? Number(auxiliary) + linkedApplied - selectedApplied
    : total - selectedApplied
}
